export interface Campaign {
  id: string
  campaignName: string
}
